import { Component, OnInit } from '@angular/core';
import { CommerceService } from '../../../../../../../services/commerce.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'add-availed-product-summary',
  standalone: false,
  templateUrl: './add-availed-product-summary.component.html',
  styleUrl: './add-availed-product-summary.component.scss',
})
export class AddAvailedProductSummaryComponent implements OnInit {

  constructor(
    private commerceService: CommerceService,
    private sanitizer: DomSanitizer
  ){}

  public productDetails: any;
  public paymentTerms: any;
  public responsiveOptions = [
    {
        breakpoint: '1199px',
        numVisible: 1,
        numScroll: 1
    },
    {
        breakpoint: '991px',
        numVisible: 2,
        numScroll: 1
    },
    {
        breakpoint: '767px',
        numVisible: 1,
        numScroll: 1
    }
  ];

  isPdfViewable: boolean = false;
  safeUrl: any;

  ngOnInit(): void {
    this.productDetails = this.commerceService.productDetailModel;
    this.paymentTerms = this.commerceService.paymentTermsModel;
  }

  getSafeUrl(url: string) {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
    this.isPdfViewable = true;
  }

  hideDialog(){
    this.isPdfViewable = false;
  }

}
